module.exports = __webpack_public_path__ + "static/media/21ECLAC51.00f0a2e9.jpg";